import { Box, Typography, Avatar } from '@mui/material';
import BottomNavbar from '../../components/shared/BottomNavbar';
import { TEXT_HOW_ARE_YOU_FEELING } from '../../constants';
import { IDashboardComponentProps } from '../../constants/types';
import { getGreetingMessage } from '../../utils';
import DateComponent from './DateComponent';
import MedicationCard from './MedicationCard';
import imgFeelingAlright from '/images/feeling-alright@2x.png';
import imgFeelingGreat from '/images/feeling-great@2x.png';
import imgFeelingLow from '/images/feeling-low@2x.png';
import UpcomingEvents from './upcomingEvents';
import { GroupedMedication } from '.';
import MESSAGES from '../../constants/message';
import { CalenderIcon } from '../../components/shared/CustomIcons';

const DashboardComponent = ({
  profileURL,
  fullName,
  formattedDates,
  appointments,
  medicationReminders,
  onLogout,
  onFeelingSelection,
  onMedicalConsistencySelection,
  onAppointmentDetailsClick,
}: IDashboardComponentProps) => {
  const imgFeelingAlrightStyle = {
    width: '52px',
    height: 'auto',
    top: '-7px',
    right: '12px',
  };

  const imgFeelingGreatStyle = {
    width: '64px',
    height: 'auto',
    top: '15px',
    right: '67px',
  };

  const imgFeelingLowStyle = {
    width: '72px',
    height: 'auto',
    bottom: '2px',
    right: '2px',
  };

  return (
    <Box bgcolor="primary.main" className="d-flex flex-column flex-1">
      <Box
        sx={{ gap: 4, pt: 8, pb: 2.5, position: 'relative' }}
        className="d-flex flex-column"
      >
        <Box
          sx={{ position: 'absolute', top: 16, right: 24, zIndex: 1 }}
          className="d-flex justify-content-center rounded-circle"
        >
          <Avatar
            src={profileURL ? profileURL : ''}
            alt="User"
            className="cursor-pointer"
            onClick={onLogout}
          />
        </Box>
        <Box sx={{ gap: 5.75, px: 3 }} className="d-flex flex-1">
          <Typography variant="h4" color="common.white">
            {getGreetingMessage()}, <br /> {fullName}!
          </Typography>
        </Box>

        <Box
          sx={{ height: 88 }}
          className="d-flex justify-content-center align-items-center"
        >
          <DateComponent formattedDates={formattedDates} />
        </Box>
      </Box>

      <Box
        sx={{ pt: 0.75, gap: '1px' }}
        className="d-flex flex-column flex-1 scroll-y"
      >
        <Box
          sx={{ bgcolor: 'info.main', py: 3.5, pl: 3, pr: 16 }}
          className="position-relative overflow-hidden rounded-50 cursor-pointer"
          onClick={onFeelingSelection}
        >
          <Typography variant="h4" sx={{ color: 'common.white' }}>
            {TEXT_HOW_ARE_YOU_FEELING}
          </Typography>
          <img
            style={imgFeelingAlrightStyle}
            src={imgFeelingAlright}
            alt="feeling alright"
            className="position-absolute"
          />
          <img
            style={imgFeelingGreatStyle}
            src={imgFeelingGreat}
            alt="feeling great"
            className="position-absolute"
          />
          <img
            style={imgFeelingLowStyle}
            src={imgFeelingLow}
            alt="feeling low"
            className="position-absolute"
          />
        </Box>
        <>
          <UpcomingEvents
            appointments={appointments}
            onAppointmentDetailsClick={onAppointmentDetailsClick}
          />
        </>

        <>
          {medicationReminders?.map((medicationReminder: GroupedMedication) => {
            return <MedicationCard medicationReminder={medicationReminder} />;
          })}
        </>
        <Box
          sx={{ bgcolor: 'info.main', py: 2.5 }}
          className="d-flex justify-content-center align-items-center rounded-50 cursor-pointer"
          onClick={onMedicalConsistencySelection}
        >
          <CalenderIcon sx={{ color: 'common.white', pr: '8px' }} />
          <Typography variant="body1" sx={{ color: 'common.white' }}>
            {MESSAGES.DASHBOARD.MEDICATION_CONSISTENCY}
          </Typography>
        </Box>
      </Box>
      <BottomNavbar />
    </Box>
  );
};

export default DashboardComponent;
